export default function Footer({ t, waLink }) {
  return (
    <footer className="pt-16 md:pt-20 pb-8 border-t border-[var(--border)] bg-[var(--bg)]">
      <div className="container-x grid grid-cols-12 gap-8 md:gap-12">
        {/* Brand column */}
        <div className="col-span-12 md:col-span-5">
          <a
            href="#top"
            className="font-display font-black text-2xl md:text-3xl tracking-tighter text-[var(--text)]"
            data-testid="footer-logo"
          >
            Next<span className="text-[var(--accent)]">·</span>Store<span className="text-[var(--accent)] text-base ml-1 font-serif-italic normal-case tracking-normal">.id</span>
          </a>
          <p className="mt-4 text-[var(--text-muted)] max-w-sm">
            {t.footer.tagline} <span className="font-serif-italic text-[var(--text)]">{t.footer.based}</span>
          </p>
        </div>

        {/* Nav */}
        <div className="col-span-6 md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display mb-4">
            {t.footer.col1}
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#work" className="text-[var(--text)] hover:text-[var(--accent)] transition-colors">
                {t.nav.work}
              </a>
            </li>
            <li>
              <a href="#services" className="text-[var(--text)] hover:text-[var(--accent)] transition-colors">
                {t.nav.services}
              </a>
            </li>
            <li>
              <a href="#process" className="text-[var(--text)] hover:text-[var(--accent)] transition-colors">
                {t.nav.process}
              </a>
            </li>
            <li>
              <a href="#pricing" className="text-[var(--text)] hover:text-[var(--accent)] transition-colors">
                {t.nav.pricing}
              </a>
            </li>
            <li>
              <a href="#faq" className="text-[var(--text)] hover:text-[var(--accent)] transition-colors">
                {t.nav.faq}
              </a>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="col-span-6 md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display mb-4">
            {t.footer.col2}
          </div>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            <li>Shopify Basic</li>
            <li>Shopify Growth</li>
            <li>Shopify Enterprise</li>
            <li>Custom Development</li>
            <li>Store Migration</li>
          </ul>
        </div>

        {/* Contact */}
        <div className="col-span-12 md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display mb-4">
            {t.footer.col3}
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--text)] hover:text-[var(--accent)] transition-colors flex items-center gap-2"
                data-testid="footer-whatsapp"
              >
                WhatsApp <span className="text-[var(--text-muted)]">+62 813 8118 9339</span>
              </a>
            </li>
            <li>
              <a
                href="mailto:halo@nextstore.id"
                className="text-[var(--text)] hover:text-[var(--accent)] transition-colors"
                data-testid="footer-email"
              >
                halo@nextstore.id
              </a>
            </li>
            <li className="text-[var(--text-muted)]">
              Menteng, Jakarta Pusat
              <br />
              Indonesia
            </li>
          </ul>
        </div>
      </div>

      {/* Big brand text */}
      <div className="container-x mt-16 overflow-hidden">
        <div
          className="font-display font-black uppercase leading-none tracking-tighter text-[24vw] md:text-[20vw] text-[var(--text)] whitespace-nowrap"
          aria-hidden
        >
          NEXTSTORE<span className="font-serif-italic text-[var(--accent)] normal-case">.id</span>
        </div>
      </div>

      <div className="container-x mt-8 pt-6 border-t border-[var(--border)] flex flex-col md:flex-row justify-between gap-3 text-xs text-[var(--text-muted)]">
        <div>
          © {new Date().getFullYear()} NextStore.id — {t.footer.rights}
        </div>
        <div className="flex items-center gap-6 font-display uppercase tracking-widest">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[var(--accent)] transition-colors"
            data-testid="footer-instagram"
          >
            Instagram
          </a>
          <a
            href="https://dribbble.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[var(--accent)] transition-colors"
            data-testid="footer-dribbble"
          >
            Dribbble
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[var(--accent)] transition-colors"
            data-testid="footer-linkedin"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
